import axios from "axios";

// MODIFIED: the base URL was hardcoded to "localhost", which only ever works on the
// machine running the server. Opening the dev site from a phone made the phone look for
// the API on *itself*, the connection was refused, and axios reported ERR_NETWORK -
// which surfaced as "Cannot reach the server. Is the backend running?".
//
// The API now follows whatever host the page itself was loaded from, so
// http://192.168.x.x:3000 talks to http://192.168.x.x:3001 automatically.
// Set REACT_APP_API_URL in a .env file to override it (e.g. for a deployed backend).
const API_PORT = process.env.REACT_APP_API_PORT || "3002";
const API_BASE_URL = process.env.REACT_APP_API_URL || "/api"
    || `${window.location.protocol}//${window.location.hostname}:${API_PORT}/api/`;

const instance = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true  // Include credentials in all requests
});

// ADDED: key the session token is stored under. Shared with AuthProvider.
export const TOKEN_STORAGE_KEY = "cloudvault_token";

// ADDED: attach the session token to every request, so individual components
// no longer need to know anything about how auth works.
instance.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// ADDED: if the server rejects the token (expired or tampered with), clear it and
// bounce to the login screen instead of leaving the app in a half-signed-in state.
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        // /me is excluded: AuthProvider calls it to test a stored token and handles
        // the failure itself, so a hard redirect here would fight with it.
        const isAuthEndpoint = error.config?.url?.includes("/login")
            || error.config?.url?.includes("/register")
            || error.config?.url?.includes("/me");

        if (error.response?.status === 401 && !isAuthEndpoint) {
            localStorage.removeItem(TOKEN_STORAGE_KEY);
            if (window.location.pathname !== "/login") {
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    }
);

// ADDED: pulls a readable message out of an axios error, used across every screen
export function getErrorMessage(error, fallback = "Something went wrong. Please try again.") {
    if (error.response?.data?.error) return error.response.data.error;
    if (error.code === "ERR_NETWORK") return `Cannot reach the server at ${API_BASE_URL}. Is the backend running?`;
    return fallback;
}

export default instance;
